export default function AboutSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        {/* Top: Two images side by side */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-14">
          <div className="rounded-2xl overflow-hidden h-64 md:h-72">
            <img
              src="https://readdy.ai/api/search-image?query=Organized%20desk%20with%20multiple%20monitors%20showing%20colorful%20spreadsheet%20charts%20and%20data%20analytics%2C%20modern%20office%20setup%2C%20morning%20sunlight%2C%20professional%20workspace%2C%20clean%20minimal%20aesthetic%2C%20productivity%20theme%2C%20warm%20wooden%20desk%20texture&width=800&height=600&seq=about-img1-v3&orientation=landscape"
              alt="AllChinaBuySpreadsheet data organization"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
          <div className="rounded-2xl overflow-hidden h-64 md:h-72">
            <img
              src="https://readdy.ai/api/search-image?query=Happy%20shopper%20browsing%20online%20store%20on%20tablet%20in%20cozy%20living%20room%2C%20warm%20evening%20ambient%20light%2C%20lifestyle%20photography%2C%20casual%20comfortable%20setting%2C%20modern%20interior%20with%20plants%2C%20authentic%20relaxed%20moment&width=800&height=600&seq=about-img2-v3&orientation=landscape"
              alt="Shopping with AllChinaBuySpreadsheet"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
        </div>

        {/* Bottom: Text Content */}
        <div className="max-w-3xl mx-auto text-center">
          <div className="flex items-center justify-center gap-2 mb-6">
            <div className="w-1.5 h-1.5 rounded-full bg-accent-500"></div>
            <span className="text-xs font-medium text-foreground-500 uppercase tracking-[0.2em]">
              What Is AllChinaBuySpreadsheet
            </span>
          </div>

          <div className="space-y-5">
            <p className="text-lg md:text-xl text-foreground-700 leading-relaxed">
              AllChinaBuySpreadsheet is a structured product discovery system that organizes China-based products into
              searchable spreadsheets. It allows users to compare pricing, quality, shipping time, and supplier reliability
              in one place. Whether you are searching for an <strong className="text-primary-600 font-semibold">all china buy spreadsheet</strong> tool or
              a comprehensive <strong className="text-primary-600 font-semibold">china product spreadsheet list</strong>, our platform delivers
              daily verified data with transparent sourcing.
            </p>
            <p className="text-lg md:text-xl text-foreground-700 leading-relaxed">
              Our <strong className="text-primary-600 font-semibold">spreadsheet shopping guide China</strong> approach
              has been refined through thousands of product verifications, ensuring every listing you see is
              price-compared, quality-checked, and scam-filtered. We built this hub because we believe curated
              data beats raw marketplace browsing — and our growing community of global buyers proves it works.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}